import { eventSource } from '@/utils/eventSource'
const baseURL = '/api-gateway/jpaas-jdata-server/front'

const api = {
  ask: baseURL + '/ask'
}
export const sseAPI = {
  ask(data) {
    return eventSource({
      method: 'POST',
      url: api.ask,
      data: data.data,
      message: data.message
    })
  }
}
